<script>
import {mapActions, mapState} from "vuex";
import SocialMediaItemCard from "@/components/SocialMediaItemCard.vue";
import Breadcrumbs from "@/components/ui/Breadcrumbs.vue";

export default {
  name: "SocialMediaDb",
  components: {Breadcrumbs, SocialMediaItemCard},
  computed: {
    ...mapState('socialMedia', ['items']),
  },
  methods: {
    ...mapActions('socialMedia', ['fetchItems']),
  },
  mounted() {
    this.fetchItems();
  }
}
</script>

<template>
  <v-row>
    <v-col cols="12">
      <breadcrumbs />
      <span class="custom-header-text new-font-bold">Social Media Datenbank</span>
    </v-col>
    <v-col cols="12">
      <p>
        <span class="font-weight-bold">Bilder, Videoclips und Textvorlagen</span><br>
        Bedienen Sie sich an unseren umfangreichen Vorlagen für Ihre Social Media Kanäle.
      </p>
    </v-col>
    <v-col v-for="item of items" :key="item.id" cols="12">
      <social-media-item-card :item="item" />
    </v-col>
  </v-row>
</template>

<style scoped>

</style>
